module.exports = __webpack_public_path__ + "img/partner-new-icon2.2916bd18.svg";